import { render } from "./iframe-responsive.vue?vue&type=template&id=91262a2a&scoped=true"
const script = {}

import "./iframe-responsive.vue?vue&type=style&index=0&id=91262a2a&scoped=true&lang=css"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91262a2a"]])

export default __exports__